module.exports = __webpack_public_path__ + "static/media/UrbanCover.7880ea64.jpg";